//自定义插件
import Vue from "vue";
import moment from "moment";
import md5 from 'blueimp-md5';
import JSEncrypt from "jsencrypt"; 
Vue.prototype.$queryUrlParams = function (url) {
  var match,
    pl = /\+/g, // Regex for replacing addition symbol with a space
    search = /([^&=]+)=?([^&]*)/g,
    decode = function (s) {
      return decodeURIComponent(s.replace(pl, " "));
    },
    query = url ? url.substring(url.lastIndexOf("?") + 1) : window.location.search.substring(1);

  var urlParams = {};
  while (match = search.exec(query))
    urlParams[decode(match[1])] = decode(match[2]);
  return urlParams;
}
Vue.prototype.$getRouterQuery = function (query, changeQuery) {
  if (!changeQuery) {
    changeQuery = {}
  };
  let newQuery = {};
  for (let i in query) {
    newQuery[i] = query[i];
  }
  for (let j in changeQuery) {
    newQuery[j] = changeQuery[j]
  }
  return newQuery;
};
Vue.prototype.$moment=moment;
//MD5插件
Vue.prototype.$md5 = md5;
//RSA加密（公钥）
Vue.prototype.$jsEncrypt = JSEncrypt;